import pageActions from '../page/actions';
import fieldActions from '../fields/actions';
import sessionActions from '../session/actions';
import dialogActions from '../dialogs/actions';
import groupActions from '../groups/actions';

export default (state = {}, action) => {
  switch (action.type) {
    case pageActions.GO_SUCCESS:
    case groupActions.UPLOAD_SUCCESS:
    case fieldActions.RERENDER_SUCCESS:
    case sessionActions.GET_SUCCESS:
      return {
        ...state,
        ...(action.payload.data.meta.timeOut || state),
      };
    case pageActions.GO:
    case sessionActions.GET:
    case fieldActions.RERENDER:
    case dialogActions.CLOSE:
    case pageActions.NEXT:
      return {
        ...state,
        reset: state.reset + 1,
      };
    default:
      return state;
  }
};
